import { useEffect, useRef, useState } from "react";
import { classNames } from "primereact/utils";
import { AdvancedImage } from "@cloudinary/react";
import { fill } from "@cloudinary/url-gen/actions/resize";
import localeText from "../../../../../locale";
import { cloudinaryInstance } from "../../../../../utilities/Cloudinary/cloudinaryInstance";

const MAX_MB = 5;

// Um espaço de imagem (ex.: Desktop · PT). Clicar escolhe um arquivo, que segue para o recorte.
const BannerSlot = ({ label, value, ratio, onPick, onInvalid }) => {
  const inputRef = useRef(null);
  const [objectUrl, setObjectUrl] = useState(null);

  useEffect(() => {
    if (!(value instanceof File)) {
      setObjectUrl(null);
      return undefined;
    }
    const url = URL.createObjectURL(value);
    setObjectUrl(url);
    return () => URL.revokeObjectURL(url);
  }, [value]);

  const handleFile = (file) => {
    if (!file) return;
    if (!file.type.startsWith("image/")) {
      onInvalid(localeText("adminFormImageInvalid"));
      return;
    }
    if (file.size / 1024 / 1024 > MAX_MB) {
      onInvalid(localeText("fileSizeTooBig"));
      return;
    }
    onPick(file);
  };

  const isNew = value instanceof File;

  return (
    <button
      type="button"
      className={classNames("admin-banner-slot", {
        "admin-banner-slot--empty": !value,
        "admin-banner-slot--new": isNew,
      })}
      style={{ aspectRatio: String(ratio) }}
      onClick={() => inputRef.current?.click()}
      onDragOver={(e) => e.preventDefault()}
      onDrop={(e) => {
        e.preventDefault();
        handleFile(e.dataTransfer.files?.[0]);
      }}
      title={localeText(value ? "adminFormImageReplace" : "adminFormImageChoose")}
    >
      {isNew && objectUrl && <img src={objectUrl} alt="" />}
      {!isNew && value && (
        <AdvancedImage
          cldImg={cloudinaryInstance.image(value).resize(fill().width(360).height(Math.round(360 / ratio)))}
          alt=""
        />
      )}
      {!value && (
        <span className="admin-banner-slot__empty">
          <i className="pi pi-plus" aria-hidden="true" />
        </span>
      )}
      <span className="admin-banner-slot__label">{label}</span>
      {isNew && <span className="admin-banner-slot__new">{localeText("adminBannersNew")}</span>}
      <span className="admin-banner-slot__overlay" aria-hidden="true">
        <i className="pi pi-upload" />
      </span>
      <input
        ref={inputRef}
        type="file"
        accept="image/*"
        hidden
        onClick={(e) => e.stopPropagation()}
        onChange={(e) => {
          handleFile(e.target.files?.[0]);
          e.target.value = "";
        }}
      />
    </button>
  );
};

export default BannerSlot;
